module.exports = __webpack_public_path__ + "img/p1.ed290d89.png";